var map = {
	"./lpg-masaze_1_after_tn.jpg": 1515,
	"./lpg-masaze_1_before_tn.jpg": 1516
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 471;



//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/ostatni nonrecursive \.(png|jpe?g|svg)$
// module id = 471
// module chunks = 0